import styles from './expand-arrow.module.css';

export interface ExpandArrowProps {
  expanded: boolean;
  className?: string;
}

export const ExpandArrow = ({ expanded, className }: ExpandArrowProps) => (
  <span className={className ? `${styles.arrowWrapper} ${className}` : styles.arrowWrapper} data-expanded={expanded}>
    <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M5.5575 6.22266L9 9.65766L12.4425 6.22266L13.5 7.28016L9 11.7802L4.5 7.28016L5.5575 6.22266Z' />
    </svg>
  </span>
);

export default ExpandArrow;
